class ErrorWithSource extends Error {
    constructor(source, ...params) {
      // Pass remaining arguments (including vendor specific ones) to parent constructor
      super(...params)
  
      // Maintains proper stack trace for where our error was thrown (only available on V8)
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, ErrorWithSource)
      }
  
      this.name = 'ErrorWithSource'
      // Custom debugging information
      this.source = source
      this.date = new Date()
    }
  }

export default ErrorWithSource;  